import { theme } from 'Assets/Styles/theme'
import { MessageErrorInput } from 'Components/Message/Error/input'
import { DATE_FORMAT } from 'constants.js'
import DatePicker from 'material-ui/DatePicker'
import moment from 'moment'
import React from 'react'

const DatePickerUnstyled = props => {
  const { input } = props

  const formatInputValue = value => (value !== '' ? value : null)
  const formatDisplayDate = date => moment(date).format(DATE_FORMAT)
  const hasError = () => props.meta.touched && props.meta.error
  const renderError = ({ meta: { error } }) =>
    hasError() ? <MessageErrorInput key="errorMessage" message={error} /> : null

  return (
    <div className={props.className}>
      {props.label && (
        <label className="label" htmlFor={input.name}>
          {props.label}
        </label>
      )}

      <DatePicker
        {...props}
        className="DatePicker"
        placeholder={props.placeholder}
        onChange={(evt, date) => props.input.onChange(date)}
        name={input.name}
        id={props.id}
        formatDate={dt => formatDisplayDate(dt)}
        value={formatInputValue(input.value)}
        textFieldStyle={{
          position: 'relative',
          width: '100%',
          borderRadius: '4px',
          height: '52px',

          background: theme.colors.alabaster,
          border: 'none',
          padding: '0 20px',
          color: theme.colors.secondary,
          outline: 'none',
        }}
      />
      {renderError(props)}
    </div>
  )
}

DatePickerUnstyled.defaultProps = {
  placeholder: moment().format(DATE_FORMAT),
}

export { DatePickerUnstyled }
